'use client';

import { useApiCall } from './useApiCall';

interface InitLandingRequest {
  tpSessionId: string;
  deviceType: string;
  utmSource: string | null;
  utmMedium: string | null;
  utmCampaign: string | null;
  utmContent: string | null;
  utmTerm: string | null;
  adGroup: string | null;
  matchType: string | null;
  referrer: string | null;
  /** Pagina di atterraggio, solo il percorso: il backend lo normalizza */
  landingPath: string;
  /** Codice invito (/invito/CODE o `?ref=`): uno sconosciuto il backend lo scarta senza far fallire init */
  inviteCode?: string;
  inviteChannel?: string | null;
}

interface InitLandingResponse {
  success: boolean;
}

export function useInitLanding() {
  const { execute, isLoading, error } = useApiCall<InitLandingRequest, InitLandingResponse>({
    endpoint: '/v1/landing/init',
    method: 'POST',
    useRequestAs: 'body',
  });

  return {
    initLanding: execute,
    isLoading,
    error,
  };
}
